/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-15 14:49:03
 * @Description  : 自动注入控制台
 */
// =================================================================

import { constConf } from '@GLOBAL/constConf';

// 动态注入控制台
function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = resolve;
    script.onerror = reject;
    document.getElementsByTagName('head')[0].appendChild(script);
  });
}

async function initVConsole() {
  try {
    if (!(constConf as any).IS_DEBUG) return
    await loadScript('https://m-c.shuntongtong.com/lib/vconsole/vconsole@3.14.6.min.js');
    const VConsole = window.VConsole;
    const vConsole = new VConsole();

    await loadScript('https://m-c.shuntongtong.com/lib/vconsole/vue-vconsole-devtools@1.0.8.js');
    const Devtools = window.vueVconsoleDevtools;
    Devtools.initPlugin(vConsole);
  } catch (error) {
    console.error('Failed to load VConsole:', error);
  }
}

initVConsole();




